import { mapKeys } from 'lodash-es'

export const VERBOSE = 'Verbose'
export const DEBUG = 'Debug'
export const INFORMATION = 'Information'
export const WARNING = 'Warning'
export const ERROR = 'Error'
export const FATAL = 'Fatal'

export const SCRAPING_LOGS_SEVERITIES = mapKeys(
  [
    { name: 'Verbose', value: VERBOSE },
    { name: 'Debug', value: DEBUG },
    { name: 'Information', value: INFORMATION },
    { name: 'Warning', value: WARNING },
    { name: 'Error', value: ERROR },
    { name: 'Fatal', value: FATAL },
  ],
  'value',
)
